/**
 * External Dependencies
 */


// Import just what we need


 import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';


import './menu.js';
import './header.js';
import './calculator.js';

import LazyLoad from "vanilla-lazyload";
new LazyLoad({
  elements_selector: `.lazy`
});

$(() => {



});
